import moment from "moment";
import React from "react";
import 'moment/locale/it';
import Utils from "../utils/utils";

export default class GeneralTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dati: [], 
            errori: this.props.errori,
            tabella: this.props.tabella,
            patrimoni: this.props.tabella.patrimoni,
            margini: this.props.tabella.margini,
            uscite: this.props.tabella.uscite,
            mesi: this.props.tabella.mesi,
            entrate: this.props.tabella.entrate,
            usciteFatture: this.props.tabella.uscite_fatture,
            investimenti: this.props.tabella.investimenti,
            spesePeriodiche: this.props.tabella.spese_periodiche,
            tasse: this.props.tabella.tasse,
            stipendi: this.props.tabella.stipendi,
            sommaUscite: this.props.tabella.somme_uscite,
            sommaEntrate: this.props.tabella.somme_entrate,
        };
    }

    componentDidUpdate() {
        if (this.props.tabella !== this.state.tabella) {
            this.setState({
                errori: this.props.errori,
                tabella: this.props.tabella,
                patrimoni: this.props.tabella.patrimoni,
                margini: this.props.tabella.margini,
                uscite: this.props.tabella.uscite,
                mesi: this.props.tabella.mesi,
                entrate: this.props.tabella.entrate,
                usciteFatture: this.props.tabella.uscite_fatture,
                investimenti: this.props.tabella.investimenti,
                spesePeriodiche: this.props.tabella.spese_periodiche,
                tasse: this.props.tabella.tasse,
                stipendi: this.props.tabella.stipendi,
                sommaUscite: this.props.tabella.somme_uscite,
                sommaEntrate: this.props.tabella.somme_entrate
            });
        }
    }

    getImportoFormatted(importo) {
        if (importo === '--')
            return '--';
        let t = Utils.getNumberString(importo.toFixed(2));
        return t + ' €';
    }

    render() {

        return (
            <div style={{ width: '100%', maxWidth: '100%', overflowX: 'scroll', display: 'flex', flexDirection: 'row', paddingBottom: 30 }}>
                <table style={{ border: '1px solid #B65220', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <th style={redColumn}>Mese</th>
                            <th style={redColumn}>Uscite fatture</th>
                            <th style={redColumn}>Spese periodiche</th>
                            <th style={redColumn}>Tasse</th>
                            <th style={redColumn}>Investimenti</th>
                            <th style={redColumn}>Stipendi</th>
                            <th style={redColumn}>Tot. uscite</th>
                        </tr>
                        {this.state.mesi && this.state.mesi.map((mese, i) => {

                        moment().locale('it');
                        let m;
                        if (mese.includes('Totale')) {
                            m = mese
                        } else {
                            m = moment(mese, 'MM/yyyy').format('MMMM YY');
                        }
                        return (
                            <tr key={Math.random()} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#FFE5E5' }}>
                                <td style={rowColumnRed}>{m}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.usciteFatture[i])}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.spesePeriodiche[i])}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.tasse[i])}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.investimenti[i])}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.stipendi[i])}</td>
                                <td style={rowColumnRed}>{this.getImportoFormatted(this.state.sommaUscite[i])}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>

                <table style={{ border: '1px solid #9ECF50', borderCollapse: 'collapse', marginLeft: 15 }}>
                    <tbody>
                        <tr>
                            <th style={greenColumn}>Entrate fatture</th>
                            <th style={greenColumn}>Tot. entrate</th>
                        </tr>
                        {this.state.mesi && this.state.mesi.map((mese, i) => {

                            return (
                                <tr key={Math.random()} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#EDFFCF' }}>
                                    <td style={rowColumnGreen}>{this.getImportoFormatted(this.state.entrate[i])}</td>
                                    <td style={rowColumnGreen}>{this.getImportoFormatted(this.state.sommaEntrate[i])}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <table style={{ border: '1px solid #E5F041', borderCollapse: 'collapse', marginLeft: 15 }}>
                    <tbody>
                        <tr>
                            <th style={yellowColor}>Bilanci</th>
                            <th style={yellowColor}>Margine mese successivo</th>
                        </tr>
                        {this.state.mesi && this.state.mesi.map((mese, i) => {

                        let isErrore = false;
                        this.state.errori.forEach(e => {
                            if (e.data.split(' ')[0].split('-')[1] == mese.split('/')[0]) {
                                isErrore = true;
                            }
                        });

                        return (
                            <tr key={Math.random()} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#FBFEAD' }}>
                                <td style={{ ...rowColumnYellow, color: isErrore ? 'red' : 'black' }}>{this.getImportoFormatted(this.state.patrimoni[i])}</td>
                                <td style={rowColumnYellow}>{this.state.margini[i] !== '-' ? this.getImportoFormatted(this.state.margini[i]) : '-'}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        );
    }
}

const firstColumn = {
    minWidth: 50,
    maxWidth: 50,
    textAlign: 'left',
    width: 50,
    height: 40,
}

const redColumn = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 40,
    border: '1px solid #B65220',
    borderCollapse: 'collapse',
}

const greenColumn = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 40,
    border: '1px solid #9ECF50',
    borderCollapse: 'collapse',
}

const yellowColor = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 40,
    border: '1px solid #E5F041',
    borderCollapse: 'collapse',
}

const rowColumnRed = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 20,
    border: '1px solid #B65220',
    borderCollapse: 'collapse',
}

const rowColumnGreen = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 20,
    border: '1px solid #9ECF50',
    borderCollapse: 'collapse',
}

const rowColumnYellow = {
    minWidth: 150,
    maxWidth: 150,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    width: 150,
    height: 20,
    border: '1px solid #E5F041',
    borderCollapse: 'collapse',
}